module.exports = __webpack_public_path__ + "img/etron-image1.aae27e1a.png";